import request from "@/utils/request";

//1,获取列表
export function getScoreRules(data){
    return request({
        url:'/admin/getScoreRules',
        data:data,
        method:'get'
    })
}
//2,添加
export function addScoreRule(data){
    return request({
        url:'/admin/addScoreRule',
        data:data,
        method:'post'
    })
}
//3,编辑
export function updateScoreRule(data){
    return request({
        url:'/admin/updateScoreRule',
        data:data,
        method:'post'
    })
}

//查询单个
export function getScoreRuleDetail(data){
    return request({
        url:'/getScoreRuleDetail',
        data:data,
        method:'get'
    })
}

//删除
export function removeScoreRule(data){
    return request({
        url:'/admin/removeScoreRule',
        data:data,
        method:'post'
    })
}
